import React from 'react';
import { Square, Flex, Copy, Image } from '@grubhubprod/gh-cookbook-react/dist';

export default function NoCertificatesMessage(): JSX.Element {
  return (
    <Square
      inset="md"
      border="1px"
      borderStyle="solid"
      borderColor="lightLine"
      borderRadius="4px"
    >
      <Flex alignItems="center" minHeight="96px">
        <Square marginRight="2">
          <Image
            width="48px"
            src="https://res.cloudinary.com/grubhub-assets/image/upload/v1639421008/corp-management-ui/page-icon.svg"
            role="presentation"
          />
        </Square>
        <Copy variant="lead" color="darkLine" strong>
          We’re gathering your tax exempt certificates. Please check back later.
        </Copy>
      </Flex>
    </Square>
  );
}
